import { inject, Injectable } from '@angular/core';
import { booleanIntersects } from '@turf/turf';
import { Feature } from 'geojson';

import { AssertService } from '@connect-services/client/services/assert.service';
import { SelectZoneLayerService } from '@connect-services/client/services/select-zone-layer.service';
import { ZoneDelimiterService } from '@connect-services/client/services/zone-delimiter.service';
import { Geometry } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionZoneSelectionService {
    private readonly selectZoneLayerService = inject(SelectZoneLayerService);
    private readonly zoneDelimiterService = inject(ZoneDelimiterService);

    public getZoneDelimiterFromDrawnPolygons(): string | undefined {
        return this.zoneDelimiterService.getZoneDelimiterFromDrawPolygons();
    }

    public getZoneDelimiterFromSelectedGeometries(): string | undefined {
        return this.zoneDelimiterService.getZoneDelimiterFromSelectedGeometries(
            this.selectZoneLayerService.selectedGeometries,
        );
    }

    public intersectsSelectedGeometries(geom?: Geometry): boolean {
        const selectedGeometries = Object.values(this.selectZoneLayerService.selectedGeometries);

        if (!geom || !selectedGeometries.length) {
            return false;
        }

        const entityFeature = this.toGeoJsonFeature(geom);

        return selectedGeometries.some((selectedGeometry: Geometry) => {
            const selectedFeature = this.toGeoJsonFeature(selectedGeometry);

            return booleanIntersects(entityFeature, selectedFeature);
        });
    }

    private toGeoJsonFeature(geometry: Geometry): Feature {
        AssertService.assertGeoJsonGeometryType(geometry);

        return {
            geometry,
            properties: {},
            type: 'Feature',
        };
    }
}
